import {
  Bell,
  CircleAlert,
  KeyRound,
  MailPlus,
  Sparkles,
  Workflow as WorkflowIcon,
  type LucideIcon,
} from 'lucide-react'
import type { NotificationKind } from '../../lib/notifications-api'

/** Icon per notification kind (UI only). */
export const KIND_ICONS: Record<NotificationKind, LucideIcon> = {
  generic: Bell,
  invitation: MailPlus,
  password_reset: KeyRound,
  mention: Sparkles,
  system: CircleAlert,
  workflow: WorkflowIcon,
}

/** Relative "time ago" formatting for notification timestamps. */
export function timeAgo(iso: string): string {
  const then = new Date(iso).getTime()
  if (Number.isNaN(then)) return ''
  const seconds = Math.round((Date.now() - then) / 1000)
  if (seconds < 45) return 'just now'
  const minutes = Math.round(seconds / 60)
  if (minutes < 60) return `${minutes}m ago`
  const hours = Math.round(minutes / 60)
  if (hours < 24) return `${hours}h ago`
  const days = Math.round(hours / 24)
  if (days < 7) return `${days}d ago`
  return new Date(iso).toLocaleDateString()
}
